import { operationSettingType } from '@/constants/operationSetting/option';
import { fulfillmentStatus } from '@/constants/operationSetting/operationSettingOptionList';
export default class DeliveryStatusFormDto {
    operationType = operationSettingType.DELIVERY_STATUS;
    hubIds;
    storeIds;
    delayTime;
    delayReason;
    // 지연 시에만 사용
    isApplyAllOrders;
    // 원활과 중단 시에만 사용
    isPause;
    constructor({ 
    // hub or store
    dialogType, itemIds, deliveryStatusType, ...formData }) {
        this[`${dialogType}Ids`] = itemIds;
        this.createDto(deliveryStatusType, formData);
    }
    createDto(deliveryStatusType, formData) {
        this[`${fulfillmentStatus[deliveryStatusType].text}Dto`](formData);
    }
    goodDto() {
        this.isPause = false;
        this.delayTime = 0;
    }
    delayDto({ delayTime, delayReason, isApplyAllOrders }) {
        this.delayTime = delayTime;
        this.delayReason = delayReason;
        this.isApplyAllOrders = isApplyAllOrders;
    }
    stopDto({ delayReason }) {
        this.isPause = true;
        this.delayReason = delayReason;
    }
    // 보류
    updateViewModelDto() {
        return {
            deliveryWorkYn: this.isPause ? 'N' : 'Y',
            addCookingTime: this.delayTime || 0,
        };
    }
}
